'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _reactPlayer = require('react-player');
var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  VideoPlayer: {
    padding: function padding(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '1.8rem 12rem' : responsiveMode === _ResponsiveModes.TABLET ? '1.8rem 8rem' : '0';
    }
  },
  reactPlayerWrapper: {
    margin: 'auto',
    paddingTop: function paddingTop(props) {
      return getPaddingTop(props);
    },
    position: 'relative'
  },
  reactPlayer: {
    position: 'absolute',
    top: '0',
    left: '0',
    border: function border(_ref2) {
      var videoUrl = _ref2.otherProperties.videoUrl;
      return videoUrl === '' ? '1px solid #b7b7b7' : 'none';
    },
    pointerEvents: function pointerEvents(_ref3) {
      var editable = _ref3.editable;
      return !editable ? 'auto' : 'none';
    }
  }
};
var getPaddingTop = function getPaddingTop(props) {
  var otherProperties = props.otherProperties;
  var aspectRatio = otherProperties.aspectRatio;
  if (aspectRatio === '16:9') return '56.25%';
  return '75%';
};
var VideoPlayer = function (_Component) {
  _inherits(VideoPlayer, _Component);
  function VideoPlayer() {
    _classCallCheck(this, VideoPlayer);
    return _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).apply(this, arguments));
  }
  _createClass(VideoPlayer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        otherProperties = _props.otherProperties,
        cssProperties = _props.cssProperties;
      var videoUrl = otherProperties.videoUrl;
      return _react2.default.createElement('div', {
        className: classes.VideoPlayer,
        style: cssProperties
      }, _react2.default.createElement('div', {
        className: classes.reactPlayerWrapper
      }, _react2.default.createElement(_reactPlayer2.default, {
        className: classes.reactPlayer,
        url: videoUrl,
        width: '100%',
        height: '100%',
        controls: true
      })));
    }
  }]);
  return VideoPlayer;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(VideoPlayer);